import { LayoutHeader } from "@/Header";
import { useAppColor } from "^/common/useAppColor";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/customer/alert")({
  component: RouteComponent,
});

function RouteComponent() {
  useAppColor({
    background: "#f5f5f5",
  });
  return (
    <div className="flex-auto">
      <LayoutHeader
        title="새로운 알림을 확인하세요"
        hasBackBtn
        hasFootPrint={false}
      />
      알림장 리스트
      <div style={{ height: 9999 }}></div>
    </div>
  );
}
